<template>
  <draggable
    v-model="listProxy"
    class="assignments-list d-flex flex-column"
    item-key="id"
    handle=".drag-handle"
    :group="{ name: 'level3', pull: true, put: ['level3'] }"
    :animation="150"
  >
    <div
      v-for="(a, aIndex) in listProxy"
      :key="a.id || aIndex"
      class="assignment-item"
    >
      <wizard-drag-zone align="center" :padding-top="0" />
      <div class="assignment-content">
        <wizard-row
          :value="a.name"
          :placeholder="placeholders.assignment"
          :has-validation-error="hasValidationError(3, aIndex)"
          :on-delete="() => onDelete(aIndex)"
          @update:value="onRename(aIndex, $event)"
        />
      </div>
    </div>
  </draggable>
</template>

<script>
import WizardDragZone from "./WizardDragZone.vue";
import WizardRow from "./WizardRow.vue";
import draggable from "vuedraggable";

export default {
  name: "AssignmentList",
  components: { WizardDragZone, WizardRow, draggable },
  props: {
    value: { type: Array, required: true },
    placeholders: { type: Object, required: true },
    hasValidationError: { type: Function, default: () => false },
  },
  computed: {
    listProxy: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    onRename(index, name) {
      const next = [...this.value];
      next[index] = { ...next[index], name };
      this.$emit("input", next);
    },
    onDelete(index) {
      const next = this.value.slice();
      next.splice(index, 1);
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.assignments-list {
  gap: 8px;
}
.assignment-item {
  display: grid;
  grid-template-columns: 24px 1fr;
  column-gap: 12px;
  width: 100%;
}
</style>
